export default "__VITE_ASSET__C7jgEu8v__"